import { useContext } from 'react'
import { PortalTooltipContext } from 'ui'
import { CopilotContext } from '../../context'
import { Input, Preset } from './style'

type Props = {
    className?: string
}

const CopilotSidebarPresets = ({ className }: Props) => {
    const { activePresetId, presets } = useContext(CopilotContext)

    return (
        <PortalTooltipContext>
            <div className={className}>
                <Input />
                {presets.map((preset) => {
                    const active = preset.id === activePresetId

                    return (
                        <Preset
                            $active={active}
                            preset={preset}
                            key={`copilot-preset-list-${preset.id}`}
                            showEllipsisMenu
                            size="medium"
                        />
                    )
                })}
            </div>
        </PortalTooltipContext>
    )
}

export default CopilotSidebarPresets
